import React from 'react'
import './CardLoader.css'
// import TypingEffect from 'react-typing-effect';


const CardLoader = () => {
    // const typedWords = "Please wait while we load the best transporters for you"
    return (
        <div>
            <div className="card_loader">
                <center><span className="text-loading">
                    <b>
                        Please wait while we load the best transporters for you...
                    </b>

                    {/* <TypingEffect
                        text={typedWords}
                        className="typed-words margin-bottom-70 Home__title-text"
                        speed={80}
                        eraseDelay={100}
                    /> */}
                </span></center>
                <div className="card-body">
                    <div className="tile">
                        <div className="logo1 loading"></div>
                        <div className="card__title loading"></div>
                        <div className="rating ">
                            <span className="fa fa-star fa-star_loader"></span>
                            <span className="fa fa-star fa-star_loader"></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                        </div>
                    </div>

                    {/* <div className="tile">
                        <div className="logo1 loading"></div>
                        <div className="card__title loading"></div>
                        <div className="rating ">
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                        </div>
                    </div>

                    <div className="tile">
                        <div className="logo1 loading"></div>
                        <div className="card__title loading"></div>
                        <div className="rating ">
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                        </div>
                    </div>

                    <div className="tile">
                        <div className="logo1 loading"></div>
                        <div className="card__title loading"></div>
                        <div className="rating ">
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                        </div>
                    </div>

                    <div className="tile">
                        <div className="logo1 loading"></div>
                        <div className="card__title loading"></div>
                        <div className="rating ">
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                        </div>
                    </div>

                    <div className="tile">
                        <div className="logo1 loading"></div>
                        <div className="card__title loading"></div>
                        <div className="rating ">
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                            <span className="fa fa-star fa-star_loader "></span>
                        </div>
                    </div> */}

                </div>


                {/* <div className="card__image loading"></div>
                <div className="card__title loading"></div>
                <div className="card__description loading"></div> */}
            </div>
        </div>
    )
}

export default CardLoader
